import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { AppearanceContextType, useAppearanceContext } from "@contexts/AppearanceContext";
import { UserContextType, useUserContext } from "@contexts/UserContext";
import { firebase } from "@firebase-local/firebase";
import { BrowserUtil } from "@util/index";
import UserAccountModal from "../../../features/user/components/UserAccountModal/UserAccountModal";
import "./UserSignUpWithReferralPage.scss";
import LifeAtLogo from "/resources/logos/LifeAt-Logo-Large.svg";

const INVITATION_TEXT = "A friend invited you to create a virtual workspace!";
const TERMS_TEXT = "By continuing, you are indicating that you accept our Terms of Service and Privacy Policy.";

const CELEBRATE_ICON = "🎉";

const VERIFY_EMAIL_CTA_TEXT =
    "⚠️ We just sent you a verification email. Please click the link to continue using LifeAt. (check your spam/junk if it's not in your inbox)";

interface UserSignUpWithReferralPageRouteParams {
    referralCode?: string;
}
interface UserSignUpWithReferralPageProps {}
export default function UserSignUpWithReferralPage(props: UserSignUpWithReferralPageProps) {
    const { referralCode } = useParams<UserSignUpWithReferralPageRouteParams>();

    const { lightMode }: AppearanceContextType = useAppearanceContext();
    const { user }: UserContextType = useUserContext();

    const [showVerifyEmailCta, setShowVerifyEmailCta] = useState<boolean>(false);

    useEffect(() => {
        if (user) {
            if (
                user.providerData[0]?.providerId === firebase.auth.EmailAuthProvider.PROVIDER_ID ||
                !user.emailVerified
            ) {
                setShowVerifyEmailCta(true);
            } else {
                BrowserUtil.redirectPersonalSpace();
            }
        }
    }, [user]);

    const referralInfoElements = (
        <>
            <span>{INVITATION_TEXT}</span>
            <span className="referral-user-account-button">
                <UserAccountModal referralCode={referralCode} />
            </span>
            <span>{TERMS_TEXT}</span>
        </>
    );

    const refreshInfo = showVerifyEmailCta ? (
        <div className="verify-email-cta">
            <h3>{VERIFY_EMAIL_CTA_TEXT}</h3>
        </div>
    ) : null;

    const mainContentToShow = showVerifyEmailCta ? refreshInfo : referralInfoElements;

    return (
        <div className={`referral-sign-up-page ${lightMode ? "light" : "dark"}`}>
            <div className="referral-together">
                <span className="referral-wrapper-top">
                    <span className="celebration-image">{CELEBRATE_ICON}</span>
                    <span>
                        <LifeAtLogo className={`lifeat-logo`} />
                    </span>

                    {mainContentToShow}
                </span>
            </div>
        </div>
    );
}
